import { useMemo } from "react";
import PropTypes from "prop-types";
import {
    getYear,
    format,
    formatDistanceToNow,
    differenceInHours,
} from "date-fns";
import { MAX_HOURS, TIMESTAMP } from "./constants";

const TimeStamp = ({ updated, publishedAtVerbal = "" }) => {
    const updatedTime = new Date(updated);

    const displayTime = useMemo(() => {
        if (updated === 0) {
            return "";
        }

        let display;
        const now = new Date();

        // between 0 and 1 hr => X mins ago
        // between 1 hr and 12 hrs => X hours ago
        if (differenceInHours(now, updatedTime) < MAX_HOURS) {
            display = formatDistanceToNow(updatedTime, {
                addSuffix: true,
            }).replace("about ", "");

            // more than 12 hrs and within the same year
        } else if (getYear(now) === getYear(updatedTime)) {
            display = format(updatedTime, TIMESTAMP.defaultFormat);

            // More than a year,  actual date plus the year, eg. September 4, 2017
        } else {
            display = format(updatedTime, TIMESTAMP.longFormat);
        }

        // On detail page, display both the published and updated
        if (publishedAtVerbal) {
            display = `Posted: ${publishedAtVerbal} | Last Updated: ${display}`;
        }
        return display;
    }, [updated, publishedAtVerbal]);

    const machineDate = updatedTime.toISOString();

    // suppressHydrationWarning allows us to ignore hydration warnings when timestamps
    // don't match between the server and the client due to latency or different timezones
    // For more read here:
    // https://react.dev/reference/react-dom/hydrate#suppressing-unavoidable-hydration-mismatch-errors
    return (
        displayTime && (
            <time
                className="timeStamp"
                dateTime={machineDate}
                data-testid="time"
                suppressHydrationWarning={true}
            >
                {displayTime}
            </time>
        )
    );
};

TimeStamp.propTypes = {
    updated: PropTypes.number.isRequired,
    publishedAtVerbal: PropTypes.string,
};

export default TimeStamp;
